import React, {Component} from 'react';

import Layout from '../../components/Layout'
import ChatRoom from '../../pages/ChatRoom'
import Loading from '../../components/Base/Loading'

class ChatRoomContainer extends Component {

	constructor(props) {
		super(props);
		this.state = {
			width: 0,
			height: 0,
			students: [],
			loading: false,
			chats: [],
			studentMap: {},
			facultyMap: {}
		};
		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
	}

	componentDidMount() {
		this.updateWindowDimensions();
		window.addEventListener('resize', this.updateWindowDimensions);
		//this.fetchUsers();
	}

	// fetchUserChatList = async (profile) => {
	//   // const {profile} = this.props;
	//   console.log('profile', profile)
	//   let chatRef = this.props.firebase.chats()
	//   let chats = []
	//   let created = await chatRef.where('creator_uid', '==', profile.id).get()
	//
	//   let joined = await chatRef.where('members', 'array-contains', profile.id).get()
	//
	//   created.docs.forEach(doc => chats.push({id: doc.id, ...doc.data()}))
	//   joined.docs.forEach(doc => chats.push({id: doc.id, ...doc.data()}))
	//
	//   this.setState({chats, loading: false})
	// }

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions);
		// this.listener()
	}

	updateWindowDimensions() {
		this.setState({width: window.innerWidth, height: window.innerHeight});
	}

	fetchUsers  = async () => {
		this.setState({loading : true});
		let studentMap = {}, facultyMap = [];
		let studentRef = await this.props.firebase.students().get();
		studentRef.docs.forEach(doc => studentMap[doc.id] = doc.data());

		let facultyRef = await this.props.firebase.faculties().get();
		facultyRef.docs.forEach(doc => facultyMap[doc.id] = doc.data());

		this.setState({
			studentMap,
			facultyMap,
			loading: false
		});
	}

	render() {
		const {loading} = this.state;
		const {profile} = this.props;
		return (
			<Layout {...this.props} noFooter noSideBar>
				{profile === null || profile === undefined || loading? <Loading/> :

					<ChatRoom {...this.props} {...this.state} />} 
			</Layout>
		);
	}
}


export default ChatRoomContainer;
